export const GET_FREE_HOURS_FOR_DATE = 'GET_FREE_HOURS_FOR_DATE';
export const GET_BUSY_DATES = 'GET_BUSY_DATES';
export const GET_FREE_RESTAURANT_HALLS = 'GET_FREE_RESTAURANT_HALLS';
export const RESERVATION_CENCELED = 'RESERVATION_CENCELED';
export const GET_ALLOWED_PEOPLE_FOR_TIME = 'GET_ALLOWED_PEOPLE_FOR_TIME';
export const FREE_TABLES_FOR_TIME = 'FREE_TABLES_FOR_TIME';
export const RESERVATION_CREATED = 'RESERVATION_CREATED';
export const SET_LOADING = 'SET_LOADING';
export const GET_CURRENT_RESERVATION_INFO = 'GET_CURRENT_RESERVATION_INFO';